import { createSelector } from 'reselect';
import { RootState } from '@reducers';
import { SecuritySettingState } from '@reducers/security-setting';

export const getSecuritySetting = (state: RootState): SecuritySettingState => state.securitySetting;
export const getSecuritySettingData = createSelector(getSecuritySetting, (securitySetting) => securitySetting?.data);
export const isSecuritySettingLoading = createSelector(
  getSecuritySetting, (securitySetting) => securitySetting?.loading,
);
